import "google-fonts";
import "regenerator-runtime/runtime";

import ChatBot from "./component/chatbot/ChatBot.jsx";
import React, { useRef, useState, useEffect } from "react";
import "./App.css";
import { db } from "./config/firebase";
import { applyColorTheme } from "./config/defaultTheme";
import { resolveWelcomeText } from "./config/widgetDefaults";
import { getDoc, doc } from "firebase/firestore";

// Hair classification endpoint on the deployed modular bot (Cloud Run); it also saves the bot reply to Firestore.
const DEFAULT_IMAGE_ANALYSIS_URL = "https://modular-bot-371280248581.asia-south1.run.app/classify-hair";

function App() {
  const [float_visible, setfloat_Visible] = useState(true);
  const [imageUrl, setImageUrl] = useState();
  const [title, setTitle] = useState();
  const [defualtMessages, setDefualtMessages] = useState([]);
  const [submenu, setSubmenu] = useState([]);
  const [imageUploadEnabled, setImageUploadEnabled] = useState(true);
  const [welcomeImage, setWelcomeImage] = useState(null);
  const [brandWelcomeText, setBrandWelcomeText] = useState(null);
  const [imageAnalysisUrl, setImageAnalysisUrl] = useState(process.env.REACT_APP_IMAGE_ANALYSIS_URL || DEFAULT_IMAGE_ANALYSIS_URL);

  const urlParams = new URLSearchParams(window.location.search);
  const currentDomain = urlParams.get("parentUrl");
  const shopId = currentDomain || "null";

  // ✅ Listen for postMessage from parent embed page
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.float_visible !== undefined) {
        // Force re-render even if value is the same
        setfloat_Visible(false);
        setTimeout(() => {
          setfloat_Visible(event.data.float_visible);
        }, 0);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // ✅ Notify parent when chat closes internally
  useEffect(() => {
    if (float_visible === false) {
      window.parent.postMessage({ action: 'close_chat' }, '*');
    }
  }, [float_visible]);

  useEffect(() => {
    const fetchImage = async () => {
      applyColorTheme();
      try {
        const docRef = doc(db, "Shopify", shopId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setImageUrl(
            // No Avatar_Link -> Header falls back to the bundled hair-care model photo
            docSnap.data().Avatar_Link || null
          );
          setTitle(docSnap.data()?.Botname || "");

          const submenu = docSnap.data()?.Submenu ?? [];
          const actionButtons = docSnap.data()?.ActionButtons ?? {};
          setDefualtMessages(actionButtons);
          setSubmenu(submenu);

          // Per-brand welcome screen + photo upload settings (all optional, set on the Shopify/<shopId> doc)
          setImageUploadEnabled(docSnap.data()?.Image_Upload_Enabled !== false);
          setWelcomeImage(docSnap.data()?.Welcome_Image || null);
          setBrandWelcomeText(docSnap.data()?.Welcome_Text || null);
          // Endpoint that analyses uploaded photos (e.g. the hair classifier in /server); falls back to the build-time env var
          setImageAnalysisUrl(
            docSnap.data()?.Image_Analysis_Url || process.env.REACT_APP_IMAGE_ANALYSIS_URL || DEFAULT_IMAGE_ANALYSIS_URL
          );

          applyColorTheme(docSnap.data()?.Color_Theme);
        }
      } catch (error) {
        console.error("Error fetching image: ", error);
      }
    };

    fetchImage();
  }, []);

 return (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100dvh",
      zIndex: 10,
      display: 'block',
    }}
    className="krunk-bg-transparent"
  >
    <div className="krunk-flex sm:krunk-justify-end sm:krunk-items-end krunk-h-full krunk-bg-transparent">
      <div className="krunk-flex krunk-flex-col krunk-h-full krunk-w-full sm:krunk-max-w-md">
        <ChatBot
          imageurl={imageUrl}
          subMenu={submenu}
          title={title}
          actionButtons={defualtMessages}
          setfloat_Visible={setfloat_Visible}
          float_visible={float_visible}
          imageUploadEnabled={imageUploadEnabled}
          welcomeImage={welcomeImage}
          welcomeText={resolveWelcomeText(brandWelcomeText, imageUploadEnabled)}
          imageAnalysisUrl={imageAnalysisUrl}
        />
      </div>
    </div>
  </div>
);
}

export default App;